import styled from "styled-components"
import { up } from "styled-breakpoints"

export const Uploader = styled.div`
  input {
    outline: none;
    border: none;
  }
`

export const UploaderBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 15px;
  min-height: auto;
  outline: none;
  & > div {
    outline: none;
  }

  ${up("md")} {
    min-height: 250px;
  }
`
